import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2';
import { NgForm } from '@angular/forms';
import { PerfilService } from 'src/app/services/service.index';

@Component({
  selector: 'app-perfiles',
  templateUrl: './perfiles.component.html',
  styles: []
})
export class PerfilesComponent implements OnInit {
  @ViewChild('agGrid') agGrid: AgGridAngular;
  private gridApi;
  private gridColumnApi;
  public columnDefs;
  public rowData: any;
  public localeText;
  public rowSelection;
  termino = '';

  listaPerfiles: any[] = [];

  constructor(
    public router: Router, private http: HttpClient,
    public servicioPerfil: PerfilService) {
      this.columnDefs = [
        {
          headerName: 'Id',
          field: 'perId',
          sortable: true,
          filter: true,
          width: 90,
        },
        {
          headerName: 'Perfil',
          field: 'perNombre',
          sortable: true,
          filter: true,
          width: 200,
        },
        {
          headerName: 'Descripcion',
          field: 'perDescripcion',
          sortable: true,
          filter: true,
          width: 250,
        },
        {
          headerName: 'Es-Administrador',
          field: 'perAdministrador',
          sortable: true,
          filter: true,
          width: 150,
        },
        {
          headerName: 'Activo',
          field: 'perActivo',
          sortable: true,
          filter: true,
          width: 90,
        },
      ];

      this.localeText = {
        page: 'Pagina',
        more: 'Mas',
        to: 'a',
        of: 'de',
        next: 'Siguiente',
        last: 'Ultimo',
        first: 'Primero',
        previous: 'Anterior',
        loadingOoo: 'Cargando...',
        selectAll: 'Seleccionar Todo',
        searchOoo: 'Buscar...',
        blanks: 'Vacio',
        filterOoo: 'Filtrar...',
        applyFilter: 'Aplicar Filtro...',
        equals: 'Igual',
        notEqual: 'No Igual',
        lessThan: 'Menor que',
        greaterThan: 'Mayor que',
        lessThanOrEqual: 'Menor o Igual que',
        greaterThanOrEqual: 'Mayor o Igual que',
        inRange: 'En Rango',
        contains: 'Contenga',
        notContains: 'No Contenga',
        startsWith: 'Comienza Con',
        endsWith: 'Finaliza Con',
        andCondition: 'Y',
        orCondition: 'O',
        group: 'Grupo',
        columns: 'Columnas',
        filters: 'Filtros',
      };
      this.rowSelection = 'single';
    }

  ngOnInit(): void {
    const dataUsuario = localStorage.getItem('usuario');
    if (+dataUsuario.indexOf('perId":1,') === -1) {
      this.router.navigate(['/dashboard']);
    }
  }

  cargarGrilla() {
    this.servicioPerfil.getObtenerGrillaxTermino('').subscribe(
      (resp) => {
        this.rowData = resp;
      },
      (err) => {
        console.log('Ocurrió un error en la carga. Intente mas tarde.');
      }
    );
  }

  onSelectionChanged(params) {
    const selectedRows = this.gridApi.getSelectedRows();
    const perId = selectedRows.length === 1 ? selectedRows[0].perId : '';
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    this.cargarGrilla();
  }

  filtrar() {
    this.buscar(this.termino);
  }

  buscar(termino: string) {
    if (termino.length <= 0) {
      this.cargarGrilla();
      return;
    }

    this.servicioPerfil.getObtenerGrillaxTermino(termino).subscribe(
      (resp) => {
        this.rowData = resp;
      },
      (err) => {
        console.log('Ocurrió un error');
      }
    );
  }

}
